import React from 'react';
import { View, TouchableOpacity, Image, Platform, StyleSheet } from 'react-native';
import PostGridDisplay from './PostGridDisplay';
import { CardInterestsDisplay } from './CardInterestsDisplay';

export function ProfileTemplateCard({
  template,
  onPress,
  onMessagePress,
  showMessageButton = true,
  interestEmojis = [],
  interestItems = [],
  showInterestEmojis = false,
  activeOpacity = 0.95,
}) {
  const items = Array.isArray(template?.items) ? template.items : [];

  return (
    <TouchableOpacity style={styles.card} onPress={onPress} activeOpacity={activeOpacity}>
      {template?.cardBackground?.type === 'color' && template.cardBackground.value ? (
        <View style={[styles.cardBgLayer, { backgroundColor: template.cardBackground.value }]} />
      ) : null}
      {template?.cardBackground?.type === 'image' && template.cardBackground.value ? (
        <Image source={{ uri: template.cardBackground.value }} style={styles.cardBgLayer} resizeMode="cover" />
      ) : null}
      {template?.cardBackground?.type === 'video' && template.cardBackground.value && Platform.OS === 'web' ? (
        <video
          src={template.cardBackground.value}
          autoPlay
          loop
          muted
          playsInline
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', borderRadius: 12, zIndex: 0 }}
        />
      ) : null}

      {(showInterestEmojis || showMessageButton) ? (
        <View style={styles.topRightActions}>
          {showMessageButton ? (
            <View style={styles.topRightButtonsRow}>
              <TouchableOpacity
                style={styles.messageBtn}
                onPress={(e) => {
                  if (e?.stopPropagation) e.stopPropagation();
                  onMessagePress?.(template);
                }}
              >
                <Image
                  source={require('../../assets/icons/paper-plane.png')}
                  style={styles.messageIcon}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            </View>
          ) : null}
          {showInterestEmojis ? (
            <View style={styles.interestsRow}>
              <CardInterestsDisplay items={interestItems} emojis={interestEmojis} />
            </View>
          ) : null}
        </View>
      ) : null}

      <PostGridDisplay items={items} cardBackground={null} suppressEmptyWidgetHints />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#feffe4',
    borderRadius: 12,
    overflow: 'visible',
    padding: 20,
    alignSelf: 'stretch',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  cardBgLayer: {
    ...StyleSheet.absoluteFillObject,
    borderRadius: 12,
    overflow: 'hidden',
    zIndex: 0,
  },
  topRightActions: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 12,
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 4,
  },
  topRightButtonsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  interestsRow: {
    alignItems: 'flex-end',
  },
  messageBtn: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageIcon: {
    width: 20,
    height: 20,
  },
});
